export { default } from './part-case-card';
